var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNexticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36.7 31.6",
    enableBackground: "new 0 0 36.7 31.6",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M19.9,21.9c-0.1,0-0.3,0-0.4-0.1c-0.2-0.2-0.2-0.5,0-0.7l5.2-5.2l-5.2-5.2c-0.2-0.2-0.2-0.5,0-0.7 s0.5-0.2,0.7,0l5.9,5.9l-5.9,5.9C20.2,21.8,20.1,21.9,19.9,21.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M25.5,16.3H10.9c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h14.6c0.3,0,0.5,0.2,0.5,0.5S25.8,16.3,25.5,16.3z "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNexticon);
export default __webpack_public_path__ + "static/media/Next icon.d407dd59043881aa85327502be0db6fb.svg";
export { ForwardRef as ReactComponent };